import { Button } from 'antd';
import { PlaceholderImage } from './SliderImages';
import noImage from '../../../assets/images/no-photo.jpg';
import trophy from '../assets/image/trophy.svg';
import { ReactComponent as AnglerIcon } from '../assets/image/circle-user.svg';
import { ReactComponent as LakeIcon } from '../assets/image/water.svg';
import { ReactComponent as CaughtIcon } from '../assets/image/calendar-clock.svg';
import { formatDateWithTime } from '../../../../../utils/date';
import { formatCatchWeight } from '../../../../fishery_profile/components/utils/catchReports';
import '../assets/css/sliders.css';

/**
 * Catch report card shared by the fishery profile slider and the embeddable
 * widget. Pass `detailsUrl` to link out in a new tab, or `onViewDetails` to
 * handle "More Details" in place.
 */
export default function CatchReportCard({ report, detailsUrl, onViewDetails }) {
  const {
    name,
    fish_species: species,
    fish_weight_lb: pounds,
    fish_weight_oz: ounces,
    lake,
    fish_caught_date: caughtDate,
    personal_best: isPersonalBest,
    image_upload: image,
  } = report;
  const summary = [species, formatCatchWeight(pounds, ounces)]
    .filter(Boolean)
    .join(' | ');

  return (
    <article className='catch-report-card'>
      <div className='catch-report-card__media'>
        <PlaceholderImage
          src={image || noImage}
          alt={species ? `${species} catch photo` : 'Catch photo'}
          className='slider-image catch-report-card__image'
        />
        {isPersonalBest && (
          <span className='catch-report-card__pb gBold'>
            <img src={trophy} alt='' />
            <abbr title='Personal best'>PB</abbr>
          </span>
        )}
      </div>

      <div className='catch-report-card__body'>
        <div className='catch-report-card__summary gMedium'>
          {name && (
            <span className='catch-report-card__item' title={name}>
              <AnglerIcon
                role='img'
                aria-label='Angler'
                className='catch-report-card__icon'
              />
              <span className='catch-report-card__text'>{name}</span>
            </span>
          )}
          {summary && (
            <span className='catch-report-card__text' title={summary}>
              {summary}
            </span>
          )}
        </div>

        <ul className='catch-report-card__meta gSemiBold'>
          {lake && (
            <li className='catch-report-card__item' title={lake}>
              <LakeIcon
                role='img'
                aria-label='Lake'
                className='catch-report-card__icon'
              />
              <span className='catch-report-card__text'>{lake}</span>
            </li>
          )}
          {caughtDate && (
            <li className='catch-report-card__item'>
              <CaughtIcon
                role='img'
                aria-label='Caught'
                className='catch-report-card__icon'
              />
              {formatDateWithTime(caughtDate)}
            </li>
          )}
        </ul>

        {detailsUrl ? (
          <a
            href={detailsUrl}
            target='_blank'
            rel='noopener noreferrer'
            aria-label='More Details on swimbooker (opens in a new tab)'
            className='catch-report-card__details gRegular'
          >
            More Details
          </a>
        ) : (
          <Button
            type='link'
            onClick={onViewDetails}
            className='catch-report-card__details gRegular'
          >
            More Details
          </Button>
        )}
      </div>
    </article>
  );
}
